import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { initFirebase } from '../lib/firebase'
import { SignupWizard, signupWizardInFlight } from '../components/signup/SignupWizard'

/**
 * /signup — desktop wrapper for the typeform-style wizard. An already
 * signed-in visitor with no wizard in flight is an existing user who typed
 * the URL — send them to the catalog instead of a signup they can't redo.
 *
 * ?type=supplier|buyer|broker preselects the account type ("Become a
 * supplier" CTAs land here) — the wizard then skips its type step.
 */
export function Signup() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const t = params.get('type')
  const initialType = t === 'supplier' || t === 'buyer' || t === 'broker' ? t : undefined

  useEffect(() => {
    const { auth } = initFirebase()
    if (auth.currentUser && !signupWizardInFlight()) navigate('/search', { replace: true })
  }, [navigate])

  return <SignupWizard initialType={initialType} onDone={() => navigate('/search', { replace: true })} />
}
